<div class="flex flex-col gap-4">
  <p-fluid>
    <form [formGroup]="transactionForm" class="flex flex-col gap-4 mt-2 mb-4">
      <p-floatlabel variant="on">
        <input pInputText formControlName="location" autocomplete="off" />
        <label>{{ 'internal.inventory.transactionCreate.location' | translate }}</label>
      </p-floatlabel>

      @if (loadingEvents()) {
        <p-skeleton height="2.625rem" />
      } @else {
        <p-floatlabel variant="on">
          <p-select
            [options]="events()"
            [showClear]="true"
            formControlName="event"
            optionLabel="name"
            optionValue="_id"
          />
          <label>{{ 'internal.inventory.transactionCreate.event' | translate }}</label>
        </p-floatlabel>
      }
    </form>
  </p-fluid>
</div>

<div class="flex justify-end gap-2 mt-4">
  <p-button
    [label]="'general.cancel' | translate"
    severity="secondary"
    (onClick)="this.dialogRef.close(null)"
  />

  <p-button
    [label]="'general.save' | translate"
    [disabled]="transactionForm.invalid"
    severity="primary"
    (onClick)="saveEdit()"
  />
</div>
